import {
  GameNoRange,
  TaggedPitchTypeLabelMap,
  ValueMap,
} from "./FilterValueMap";
// import { PlayerNameIDMap } from "./PlayerMaps";
import { getDecimalData, getPercentageData } from "./utilFuncs";

export const wrapFilterRequestData = (formData) => {
  // console.log(formData)

  // Key Map for plays contains mulitple types
  const specialValues = {
    OUT: [
      "G",
      "G-",
      "GT",
      "F",
      "SH",
      "SF",
      "IF",
      "INT",
      "LO",
      "OT-PO",
      "UN-IO",
      "DP",
      "TP",
      "K",
      "Ks",
      "K-SF",
      "K-DO",
      "K-DS",
      "K-BF",
      "K-BS",
      "FOT",
    ],
    FO: ["F", "IF", "SF"],
    GO: ["G", "G-", "GT", "SH", "DP", "TP"],
    HR: ["HR", "IHR"],
    E: ["E-C", "E-T", "E-SF", "E-SHC", "E-SHT"],
    SF: ["SF", "E-SF"],
    SH: ["SH", "E-SHT", "E-SHC", "FSH"],
    BB: ["BB", "BB-I", "BB-IL"],
    SO: ["K", "Ks", "K-SF", "K-DO", "K-BF", "K-DS", "K-BS"],
  };
  // If Velocity range has not been set (same as default), set as false
  if (
    formData["APP_VeloRel_Min"] === formData["APP_VeloRel_Max"] &&
    formData["APP_VeloRel_Max"] === 80
  ) {
    formData["APP_VeloRel_Max"] = false;
    formData["APP_VeloRel_Min"] = false;
  }
  // If Exit Velocity range has not been set (same as default), set as false
  if (
    formData["ExitVelo_Min"] === formData["ExitVelo_Max"] &&
    formData["ExitVelo_Max"] === 0
  ) {
    formData["ExitVelo_Min"] = false;
    formData["ExitVelo_Max"] = false;
  }
  // If Exit Angle has not been set (same as default), set as false
  if (
    formData["ExitAngle_Min"] === formData["ExitAngle_Max"] &&
    formData["ExitAngle_Max"] === -90
  ) {
    formData["ExitAngle_Max"] = false;
    formData["ExitAngle_Min"] = false;
  }
  // If Velocity min > max (same as default), swap 2 values
  if (formData["APP_VeloRel_Min"] > formData["APP_VeloRel_Max"]) {
    let tmp = formData["APP_VeloRel_Min"];
    formData["APP_VeloRel_Min"] = formData["APP_VeloRel_Max"];
    formData["APP_VeloRel_Max"] = tmp;
  }
  // If Exit Velocity min > max (same as default), swap 2 values
  if (formData["ExitVelo_Min"] > formData["ExitVelo_Max"]) {
    let tmp = formData["ExitVelo_Min"];
    formData["ExitVelo_Min"] = formData["ExitVelo_Max"];
    formData["ExitVelo_Max"] = tmp;
  }
  // If Exit Angle min > max (same as default), swap 2 values
  if (formData["ExitAngle_Min"] > formData["ExitAngle_Max"]) {
    let tmp = formData["ExitAngle_Max"];
    formData["ExitAngle_Max"] = formData["ExitAngle_Min"];
    formData["ExitAngle_Min"] = tmp;
  }

  let output = {};
  // Traverse through form data
  for (const key in formData) {
    // Continue if value of formData[key] is undefined/false/[]
    if (
      !formData[key] ||
      (Array.isArray(formData[key]) && formData[key][0] === undefined)
    )
      continue;
    // Process data by key
    if (key === "BatSList" || key === "PTList" || key === "ZBList") {
      output[key] = [...formData[key]];
    } else if (key === "PCList") {
      // filtered out invalid value for database
      output[key] = formData[key]
        .filter((e) => e !== "所有揮擊")
        .map((e) => ValueMap[key][e]);
    } else if (key === "HTList") {
      // filtered out invalid value for database
      output[key] = formData[key]
        .filter((e) => e !== "所有飛球")
        .map((e) => ValueMap[key][e]);
    } else if (key === "PRList") {
      let init = [];
      for (const val of formData[key]) {
        if (specialValues[ValueMap[key][val]] !== undefined) {
          // expand special values with the pre-defined map above
          init = [...init, ...specialValues[ValueMap[key][val]]];
        } else {
          // filtered out invalid value for database, append non special value to array
          if (val === "安打") continue;
          init.push(ValueMap[key][val]);
        }
      }
      // transform the value array to set and revert to remove repetitive value
      let initSet = new Set(init);
      let arr = Array.from(initSet);
      output[key] = arr;
    } else if (key === "Hardness") {
      let tags = [],
        barrel = [];
      // seperate hardness and barrel list and transform corresponing tags to the format in DB
      for (let tag of formData[key]) {
        if (tag === "強勁" || tag === "一般" || tag === "軟弱") {
          tags.push(ValueMap["HardTList"][tag]);
        } else {
          barrel.push(ValueMap["BarrelList"][tag]);
        }
      }
      output["BarrelList"] = barrel;
      output["HardTList"] = tags;
    } else if (key === "BSList") {
      // filtered out invalid value for database
      output[key] = formData[key].filter(
        (e) => !["投手領先", "打者領先", "平手"].includes(e),
      );
    } else if (key === "OBList") {
      // encode on-base condition information (via binary representation)
      let operation = "";
      if (formData[key].includes("壘上無人")) {
        // set disjoint query to OOD value (max = 7) -> will display no corresponding data
        if (formData[key].length !== 1) operation = ">8";
        else operation = "=0";
      } else {
        if (formData[key].includes("得點圈有人")) {
          if (formData[key].includes(1) && formData[key].length === 2) {
            // set disjoint query to OOD value (max = 7) -> will display no corresponding data
            operation = ">8";
          } else if (formData[key].length === 1) {
            operation = ">1";
          } else {
            let sum = 0;
            // encode on-base condition information
            for (let n of formData[key]) sum += ValueMap["OBList"][n];
            operation = `=${sum}`;
          }
        } else {
          let sum = 0;
          // encode on-base condition information
          for (let n of formData[key]) sum += ValueMap["OBList"][n];
          operation = `=${sum}`;
        }
      }
      output[key] = operation;
    } else if (key === "Bteam") {
      // only assign value if valid option is selected
      if (
        [
          "中信兄弟",
          "富邦悍將",
          "統一7-ELEVEn獅",
          "樂天桃猿",
          "味全龍",
          "台鋼雄鷹",
        ].includes(formData[key])
      )
        output.BatterTeam = formData[key];
    } else if (key === "Pteam") {
      // only assign value if valid option is selected
      if (
        [
          "中信兄弟",
          "富邦悍將",
          "統一7-ELEVEn獅",
          "樂天桃猿",
          "味全龍",
          "台鋼雄鷹",
        ].includes(formData[key])
      )
        output.PitcherTeam = formData[key];
    } else if (key === "GameType") {
      // set up gameno range
      output.GameType = GameNoRange[formData[key]];
    } else {
      // set query content
      if (Array.isArray(formData[key])) {
        output[key] = [];
        for (let val of formData[key]) {
          output[key].push(ValueMap[key][val]);
        }
      } else {
        output[key] =
          ValueMap[key] === undefined
            ? formData[key]
            : ValueMap[key][formData[key]];
      }
    }
  }
  // resolve selected player information
  if (output.PitcherObj) {
    // output.pid = PlayerNameIDMap[output.Pitcher]
    output.Pitcher = output.PitcherObj.label;
    output.pid = output.PitcherObj.id;
  }
  if (output.BatterObj) {
    // output.bid = PlayerNameIDMap[output.Batter]
    output.Batter = output.BatterObj.label;
    output.bid = output.BatterObj.id;
  }
  if (output.CatcherObj) {
    // output.cid = PlayerNameIDMap[output.Catcher]
    output.Catcher = output.CatcherObj.label;
    output.cid = output.CatcherObj.id;
  }
  // set league as CPBL
  output.League = "J61qWKmDQnVG3VoARPPgm4hAWuaCai0";
  // console.log(output)
  return output;
};

// value set for different tags
const strk_set = ["In-Play", "Inplay", "Strk-C", "Strk-S", "Foul"];
const non_ab_set = [
  "BB",
  "BB-I",
  "BB-IL",
  "IBB",
  "SH",
  "SF",
  "E-SF",
  "FSH",
  "E-SHC",
  "E-SHT",
  "HBP",
  "OBC",
];
const hit_set = ["1B", "2B", "3B", "HR", "IHR"];
const k_set = ["K", "Ks", "K-SF", "K-DO", "K-DS", "K-BF", "K-BS"];
const bb_set = ["BB", "BB-IL", "BB-I"];
const tb_map = { "2B": 2, "3B": 3, HR: 4, IHR: 4 };
export const hittype_map = {
  GROUND: "gb",
  LINE: "ld",
  FLYB: "fb",
  POPB: "ifb",
};
export const getHitDirectionTag = (batterSide, theta) => {
  // attach hit direction tag
  theta = parseFloat(theta);
  // reverse angle if batter batting side is left (default as right)
  if (batterSide === 1) theta = 180 - theta;
  if (theta >= 35 && theta < 75) return "oppo";
  if (theta >= 75 && theta <= 105) return "straight";
  if (theta > 105 && theta <= 145) return "pull";
};

export const resolveFilterResult = (
  data,
  byPitcher = false,
  byBatter = false,
) => {
  // output structure
  const output = {
    chart: { zone: [], field: [] },
    discipline: [],
    score: [],
    hit: [],
  };
  // statistic accumulatiion template
  const grepData = {
    discipline: {
      count: 0,
      strk: 0,
      zswing: 0,
      oswing: 0,
      zcount: 0,
      ocount: 0,
      contact: 0,
      zcontact: 0,
      ocontact: 0,
      miss: 0,
      whiff: 0,
      swing: 0,
      inplay: 0,
    },
    score: {
      pa: 0,
      ab: 0,
      h: 0,
      ab_r: 0,
      ab_l: 0,
      h_r: 0,
      h_l: 0,
      obp: 0,
      xbh: 0,
      sf: 0,
      k: 0,
      bb: 0,
      hr: 0,
      tb: 0,
      ihr: 0,
    },
    hit: {
      gb: 0,
      ld: 0,
      fb: 0,
      ifb: 0,
      hard: 0,
      soft: 0,
      med: 0,
      oppo: 0,
      straight: 0,
      pull: 0,
    },
  };
  let groupByPitchType = { all: { ...grepData } };
  // use set for keeping game count
  groupByPitchType.all.gameSet = new Set();
  for (const d of data) {
    // console.log(d)
    let pitch_type_tag = d.TaggedPitchType; // === 'FT'? 'FB':d.TaggedPitchType
    // Chart Data
    const invalid_set = [null, undefined, 0, "0", ""];
    // append zone chart data if pitch location is valid
    if (
      !invalid_set.includes(d.APP_KZoneY) ||
      !invalid_set.includes(d.APP_KZoneZ)
    ) {
      output.chart.zone.push({
        label: pitch_type_tag,
        x: d.APP_KZoneY,
        y: d.APP_KZoneZ,
        g: d.GameNo,
        p: d.Pitcher,
        b: d.Batter,
        inn: d.Inning,
        v: d.APP_VeloRel,
        count: `${d.Balls}-${d.Strikes}`,
        vname: d.GameNo,
        tcode: d.VideoTimePart,
        year: d.Year,
        plateid: d.plate_id,
      });
    }
    // append hit location data if drop location is valid
    if (d.PitchCode === "In-Play") {
      if (!invalid_set.includes(d.LocX) || !invalid_set.includes(d.LocY)) {
        if (hit_set.includes(d.PA_Result)) {
          output.chart.field.push({
            label: `H-${d.HitType}`,
            x: d.LocX,
            y: d.LocY,
            g: d.GameNo,
            p: d.Pitcher,
            b: d.Batter,
            inn: d.Inning,
            pr: d.PA_Result,
            count: `${d.Balls}-${d.Strikes}`,
            vname: d.GameNo,
            tcode: d.VideoTimePart,
            year: d.Year,
            plateid: d.plate_id,
          }); // map_idx: output.chart.zone.length-1
        } else {
          output.chart.field.push({
            label: `OUT-${d.HitType}`,
            x: d.LocX,
            y: d.LocY,
            g: d.GameNo,
            p: d.Pitcher,
            b: d.Batter,
            inn: d.Inning,
            pr: d.PA_Result,
            count: `${d.Balls}-${d.Strikes}`,
            vname: d.GameNo,
            tcode: d.VideoTimePart,
            year: d.Year,
            plateid: d.plate_id,
          }); // map_idx: output.chart.zone.length-1
        }
        // output.chart.zone[output.chart.zone.length-1].map_idx = output.chart.field.length-1
      }
    }
    // Discipline
    // create new instance if one pitch type is not yet counted
    if (groupByPitchType[pitch_type_tag] === undefined) {
      groupByPitchType[pitch_type_tag] = {
        discipline: {
          count: 0,
          strk: 0,
          zswing: 0,
          oswing: 0,
          zcount: 0,
          ocount: 0,
          contact: 0,
          zcontact: 0,
          ocontact: 0,
          miss: 0,
          whiff: 0,
          swing: 0,
          inplay: 0,
        },
        score: {
          pa: 0,
          ab: 0,
          h: 0,
          ab_r: 0,
          ab_l: 0,
          h_r: 0,
          h_l: 0,
          obp: 0,
          xbh: 0,
          sf: 0,
          k: 0,
          bb: 0,
          hr: 0,
          tb: 0,
          ihr: 0,
        },
        hit: {
          gb: 0,
          ld: 0,
          fb: 0,
          ifb: 0,
          hard: 0,
          soft: 0,
          med: 0,
          oppo: 0,
          straight: 0,
          pull: 0,
        },
      };
      groupByPitchType[pitch_type_tag].gameSet = new Set();
    }
    // update cumulated data
    groupByPitchType[pitch_type_tag].discipline.count++;
    groupByPitchType.all.discipline.count++;
    if (d.PitchCode === "In-Play") {
      groupByPitchType[pitch_type_tag].discipline.inplay++;
      groupByPitchType.all.discipline.inplay++;
      //Hit
      groupByPitchType[pitch_type_tag].hit[hittype_map[d.HitType]]++;
      groupByPitchType.all.hit[hittype_map[d.HitType]]++;
      groupByPitchType[pitch_type_tag].hit[d.HardnessTag.toLowerCase()]++;
      groupByPitchType.all.hit[d.HardnessTag.toLowerCase()]++;
      let dirTag = getHitDirectionTag(d.BatS, d.Theta);
      groupByPitchType[pitch_type_tag].hit[dirTag]++;
      groupByPitchType.all.hit[dirTag]++;
    }
    if (strk_set.includes(d.PitchCode)) {
      groupByPitchType[pitch_type_tag].discipline.strk++;
      groupByPitchType.all.discipline.strk++;
      if (parseInt(d.Zone)) {
        if (d.PitchCode !== "Strk-C") {
          groupByPitchType[pitch_type_tag].discipline.zswing++;
          groupByPitchType.all.discipline.zswing++;
          groupByPitchType[pitch_type_tag].discipline.swing++;
          groupByPitchType.all.discipline.swing++;
          if (d.PitchCode !== "Strk-S") {
            groupByPitchType[pitch_type_tag].discipline.zcontact++;
            groupByPitchType.all.discipline.zcontact++;
            groupByPitchType[pitch_type_tag].discipline.contact++;
            groupByPitchType.all.discipline.contact++;
          } else {
            groupByPitchType[pitch_type_tag].discipline.whiff++;
            groupByPitchType.all.discipline.whiff++;
          }
        } else {
          groupByPitchType[pitch_type_tag].discipline.miss++;
          groupByPitchType.all.discipline.miss++;
        }
      } else {
        if (d.PitchCode !== "Strk-C") {
          groupByPitchType[pitch_type_tag].discipline.oswing++;
          groupByPitchType.all.discipline.oswing++;
          groupByPitchType[pitch_type_tag].discipline.swing++;
          groupByPitchType.all.discipline.swing++;
          if (d.PitchCode !== "Strk-S") {
            groupByPitchType[pitch_type_tag].discipline.ocontact++;
            groupByPitchType.all.discipline.ocontact++;
            groupByPitchType[pitch_type_tag].discipline.contact++;
            groupByPitchType.all.discipline.contact++;
          } else {
            groupByPitchType[pitch_type_tag].discipline.whiff++;
            groupByPitchType.all.discipline.whiff++;
          }
        } else {
          groupByPitchType[pitch_type_tag].discipline.miss++;
          groupByPitchType.all.discipline.miss++;
        }
      }
    }
    if (parseInt(d.Zone)) {
      groupByPitchType[pitch_type_tag].discipline.zcount++;
      groupByPitchType.all.discipline.zcount++;
    } else {
      groupByPitchType[pitch_type_tag].discipline.ocount++;
      groupByPitchType.all.discipline.ocount++;
    }
    // Score
    // count game set to obtain game count
    groupByPitchType[pitch_type_tag].gameSet.add(parseInt(d.GameNo));
    groupByPitchType.all.gameSet.add(parseInt(d.GameNo));
    if (d.PA_Result !== null && d.PA_Result[0] !== undefined) {
      groupByPitchType[pitch_type_tag].score.pa++;
      groupByPitchType.all.score.pa++;
      // update at bat data by filtering play results
      if (!non_ab_set.includes(d.PA_Result)) {
        groupByPitchType[pitch_type_tag].score.ab++;
        groupByPitchType.all.score.ab++;
        if (byBatter ^ byPitcher) {
          if (byBatter) {
            if (d.PT === 0) {
              groupByPitchType[pitch_type_tag].score.ab_r++;
              groupByPitchType.all.score.ab_r++;
            } else {
              groupByPitchType[pitch_type_tag].score.ab_l++;
              groupByPitchType.all.score.ab_l++;
            }
          } else {
            if (d.BatS === 0) {
              groupByPitchType[pitch_type_tag].score.ab_r++;
              groupByPitchType.all.score.ab_r++;
            } else {
              groupByPitchType[pitch_type_tag].score.ab_l++;
              groupByPitchType.all.score.ab_l++;
            }
          }
        }
      }
      if (hit_set.includes(d.PA_Result)) {
        groupByPitchType[pitch_type_tag].score.h++;
        groupByPitchType.all.score.h++;
        if (byBatter ^ byPitcher) {
          if (byBatter) {
            if (d.PT === 0) {
              groupByPitchType[pitch_type_tag].score.h_r++;
              groupByPitchType.all.score.h_r++;
            } else {
              groupByPitchType[pitch_type_tag].score.h_l++;
              groupByPitchType.all.score.h_l++;
            }
          } else {
            if (d.BatS === 0) {
              groupByPitchType[pitch_type_tag].score.h_r++;
              groupByPitchType.all.score.h_r++;
            } else {
              groupByPitchType[pitch_type_tag].score.h_l++;
              groupByPitchType.all.score.h_l++;
            }
          }
        }
        if (tb_map[d.PA_Result] !== undefined) {
          groupByPitchType[pitch_type_tag].score.xbh++;
          groupByPitchType.all.score.xbh++;
          groupByPitchType[pitch_type_tag].score.tb += tb_map[d.PA_Result];
          groupByPitchType.all.score.tb += tb_map[d.PA_Result];
          if (d.PA_Result === "HR") {
            groupByPitchType[pitch_type_tag].score.hr++;
            groupByPitchType.all.score.hr++;
          }
          if (d.PA_Result === "IHR") {
            groupByPitchType[pitch_type_tag].score.ihr++;
            groupByPitchType.all.score.ihr++;
          }
        } else {
          groupByPitchType[pitch_type_tag].score.tb++;
          groupByPitchType.all.score.tb++;
        }
      }
      if (
        hit_set.includes(d.PA_Result) ||
        bb_set.includes(d.PA_Result) ||
        d.PA_Result === "IBB" ||
        d.PA_Result === "HBP"
      ) {
        groupByPitchType[pitch_type_tag].score.obp++;
        groupByPitchType.all.score.obp++;
      }
      if (d.PA_Result === "SF" || d.PA_Result === "E-SF") {
        groupByPitchType[pitch_type_tag].score.sf++;
        groupByPitchType.all.score.sf++;
      }
      if (k_set.includes(d.PA_Result)) {
        groupByPitchType[pitch_type_tag].score.k++;
        groupByPitchType.all.score.k++;
      }
      if (bb_set.includes(d.PA_Result)) {
        groupByPitchType[pitch_type_tag].score.bb++;
        groupByPitchType.all.score.bb++;
      }
    }
  }
  // add all fastball type
  if (
    groupByPitchType["FB"] !== undefined &&
    groupByPitchType["FT"] !== undefined
  ) {
    groupByPitchType["ALFB"] = {
      discipline: {
        count: 0,
        strk: 0,
        zswing: 0,
        oswing: 0,
        zcount: 0,
        ocount: 0,
        contact: 0,
        zcontact: 0,
        ocontact: 0,
        miss: 0,
        whiff: 0,
        swing: 0,
        inplay: 0,
      },
      score: {
        pa: 0,
        ab: 0,
        h: 0,
        ab_r: 0,
        ab_l: 0,
        h_r: 0,
        h_l: 0,
        obp: 0,
        xbh: 0,
        sf: 0,
        k: 0,
        bb: 0,
        hr: 0,
        tb: 0,
        ihr: 0,
      },
      hit: {
        gb: 0,
        ld: 0,
        fb: 0,
        ifb: 0,
        hard: 0,
        soft: 0,
        med: 0,
        oppo: 0,
        straight: 0,
        pull: 0,
      },
      gameSet: new Set([
        ...groupByPitchType["FB"].gameSet,
        ...groupByPitchType["FT"].gameSet,
      ]),
    };
    for (const t of ["FB", "FT"]) {
      for (const s of ["discipline", "score", "hit"]) {
        for (const k in groupByPitchType[t][s]) {
          groupByPitchType["ALFB"][s][k] += groupByPitchType[t][s][k];
        }
      }
    }
  }
  // console.log(groupByPitchType)
  // Calculate for Result
  for (let tag in groupByPitchType) {
    //discipline
    let dcp = [];
    dcp.push(groupByPitchType[tag].discipline.count);
    dcp.push(
      getPercentageData(
        groupByPitchType[tag].discipline.count,
        groupByPitchType.all.discipline.count,
      ),
    );
    dcp.push(groupByPitchType[tag].discipline.strk);
    dcp.push(
      getPercentageData(
        groupByPitchType[tag].discipline.strk,
        groupByPitchType[tag].discipline.count,
      ),
    );
    dcp.push(groupByPitchType[tag].discipline.zcount);
    dcp.push(
      getPercentageData(
        groupByPitchType[tag].discipline.zcount,
        groupByPitchType[tag].discipline.count,
      ),
    );
    dcp.push(groupByPitchType[tag].discipline.swing);
    dcp.push(
      getPercentageData(
        groupByPitchType[tag].discipline.swing,
        groupByPitchType[tag].discipline.count,
      ),
    );
    dcp.push(
      getPercentageData(
        groupByPitchType[tag].discipline.swing,
        groupByPitchType[tag].discipline.strk,
      ),
    );
    dcp.push(
      getPercentageData(
        groupByPitchType[tag].discipline.zswing,
        groupByPitchType[tag].discipline.zcount,
      ),
    );
    dcp.push(
      getPercentageData(
        groupByPitchType[tag].discipline.oswing,
        groupByPitchType[tag].discipline.ocount,
      ),
    );
    dcp.push(groupByPitchType[tag].discipline.contact);
    dcp.push(
      getPercentageData(
        groupByPitchType[tag].discipline.contact,
        groupByPitchType[tag].discipline.swing,
      ),
    );
    dcp.push(
      getPercentageData(
        groupByPitchType[tag].discipline.zcontact,
        groupByPitchType[tag].discipline.zswing,
      ),
    );
    dcp.push(
      getPercentageData(
        groupByPitchType[tag].discipline.ocontact,
        groupByPitchType[tag].discipline.oswing,
      ),
    );
    dcp.push(groupByPitchType[tag].discipline.whiff);
    dcp.push(
      getPercentageData(
        groupByPitchType[tag].discipline.whiff,
        groupByPitchType[tag].discipline.swing,
      ),
    );
    dcp.push(
      getPercentageData(
        groupByPitchType[tag].discipline.whiff,
        groupByPitchType[tag].discipline.strk,
      ),
    );
    dcp.push(groupByPitchType[tag].discipline.inplay);
    dcp.push(
      getPercentageData(
        groupByPitchType[tag].discipline.inplay,
        groupByPitchType[tag].discipline.count,
      ),
    );
    output.discipline.push({ title: TaggedPitchTypeLabelMap[tag], data: dcp });
    //score
    let scr = [];
    scr.push(
      getDecimalData(
        groupByPitchType[tag].score.h,
        groupByPitchType[tag].score.ab,
      ),
    );
    scr.push(
      getDecimalData(
        groupByPitchType[tag].score.h_l,
        groupByPitchType[tag].score.ab_l,
      ),
    );
    scr.push(
      getDecimalData(
        groupByPitchType[tag].score.h_r,
        groupByPitchType[tag].score.ab_r,
      ),
    );
    scr.push(
      getDecimalData(
        groupByPitchType[tag].score.obp,
        groupByPitchType[tag].score.pa,
      ),
    );
    scr.push(
      getDecimalData(
        groupByPitchType[tag].score.tb,
        groupByPitchType[tag].score.ab,
      ),
    );
    scr.push(getDecimalData(scr.at(-1) + scr.at(-2), 1));
    scr.push(
      getDecimalData(
        groupByPitchType[tag].score.h - groupByPitchType[tag].score.hr,
        groupByPitchType[tag].score.ab -
          groupByPitchType[tag].score.k -
          groupByPitchType[tag].score.hr +
          groupByPitchType[tag].score.sf,
      ),
    );
    scr.push(
      getPercentageData(
        groupByPitchType[tag].score.k,
        groupByPitchType[tag].score.pa,
      ),
    );
    scr.push(
      getPercentageData(
        groupByPitchType[tag].score.obp - groupByPitchType[tag].score.h,
        groupByPitchType[tag].score.pa,
      ),
    );
    scr.push(groupByPitchType[tag].gameSet.size);
    scr.push(groupByPitchType[tag].score.pa);
    scr.push(groupByPitchType[tag].score.ab);
    scr.push(groupByPitchType[tag].score.h);
    scr.push(groupByPitchType[tag].score.xbh);
    scr.push(groupByPitchType[tag].score.hr + groupByPitchType[tag].score.ihr);
    scr.push(groupByPitchType[tag].score.tb);
    scr.push(groupByPitchType[tag].score.k);
    scr.push(groupByPitchType[tag].score.obp - groupByPitchType[tag].score.h);
    output.score.push({ title: TaggedPitchTypeLabelMap[tag], data: scr });
    //hit
    let hitd = [];
    hitd.push(
      getPercentageData(
        groupByPitchType[tag].hit.gb,
        groupByPitchType[tag].discipline.inplay,
      ),
    );
    hitd.push(
      getPercentageData(
        groupByPitchType[tag].hit.ld,
        groupByPitchType[tag].discipline.inplay,
      ),
    );
    hitd.push(
      getPercentageData(
        groupByPitchType[tag].hit.fb,
        groupByPitchType[tag].discipline.inplay,
      ),
    );
    hitd.push(
      getPercentageData(
        groupByPitchType[tag].hit.ifb,
        groupByPitchType[tag].discipline.inplay,
      ),
    );
    // TODO: [0811] hardhit -> barrel still unable to determined
    for (let i = 0; i < 8; i++) hitd.push("-");
    let pso =
      groupByPitchType[tag].hit.pull +
      groupByPitchType[tag].hit.straight +
      groupByPitchType[tag].hit.oppo;
    hitd.push(
      getPercentageData(
        groupByPitchType[tag].hit.soft,
        groupByPitchType[tag].discipline.inplay,
      ),
    );
    hitd.push(
      getPercentageData(
        groupByPitchType[tag].hit.med,
        groupByPitchType[tag].discipline.inplay,
      ),
    );
    hitd.push(
      getPercentageData(
        groupByPitchType[tag].hit.hard,
        groupByPitchType[tag].discipline.inplay,
      ),
    );
    hitd.push(getPercentageData(groupByPitchType[tag].hit.pull, pso));
    hitd.push(getPercentageData(groupByPitchType[tag].hit.straight, pso));
    hitd.push(getPercentageData(groupByPitchType[tag].hit.oppo, pso));
    output.hit.push({ title: TaggedPitchTypeLabelMap[tag], data: hitd });
  }
  return output;
};

export const resolveFilterLeagueData = (data) => {
  const default_entries = {
    discipline: [
      "Total#",
      "Total%",
      "strike#",
      "strike%",
      "Zone#",
      "Zone%",
      "Swing#",
      "Swing%",
      "Stk_Swing%",
      "Z-Swing%",
      "O-Swing%",
      "Contact#",
      "Contact%",
      "Z-Contact%",
      "O-Contact%",
      "Miss#",
      "Whiff%",
      "Swtr%",
      "InPlay#",
      "InPlay%",
    ],
    score: [
      "AVG",
      "AVG L",
      "AVG R",
      "OBP",
      "SLG",
      "OPS",
      "BABIP",
      "K%",
      "BB%",
      "G",
      "PA",
      "AB",
      "H",
      "XBH",
      "HR",
      "TB",
      "SO",
      "BB",
    ],
    hit: [
      "GB%",
      "LD%",
      "FB%",
      "IFFB%",
      "HardHit%",
      "SweetSpot%",
      "Weak%",
      "Topped%",
      "Under%",
      "Flare/Burner",
      "Solid%",
      "Barrel%",
      "Soft%",
      "Med%",
      "Hard%",
      "Pull%",
      "Straight%",
      "Oppo%",
    ],
  };
  let output = {
    discipline: [],
    score: [],
    hit: [],
  };

  for (let t in default_entries) {
    for (let e of default_entries[t]) {
      output[t].push(data[e]);
    }
  }

  return output;
};
